import { IncomingMessage } from 'http';

import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import { fetchModels } from '../../../services/vehicles';

const getModels = (
  options: {
    locale: string;
    brand: string;
    top_models?: boolean;
  },
  req?: IncomingMessage
): [
  QueryKey,
  (options: QueryFunctionContext) => ReturnType<typeof fetchModels>
] => [
  [
    'models',
    {
      locale: options.locale,
      slug: options.brand,
      top_models: options.top_models,
    },
  ],
  ({
    queryKey: [, key],
  }: {
    queryKey: [string, { locale: string; slug: string; top_models?: boolean }];
  }) => fetchModels(key, req),
];

export default getModels;
